export default {
    dealer_alert_logs_title: "Dealer Alert Logs",
    dealer_alert_logs_id: "ID",
    dealer_alert_logs_timestamp: "Timestamp",
    dealer_alert_logs_company_id: "Account",
    dealer_alert_logs_device_id: "Device",
    dealer_alert_logs_filter_company: "Account",
    dealer_alert_logs_filter_device: "Device",
    dealer_alert_logs_filter_date_range: "Date Range",
    dealer_alert_logs_alert_type: "Alert Type",
    dealer_alert_logs_payload: "Payload",
    dealer_alert_logs_view: "View",
    dealer_alert_logs_webhook_status: "Webhook Status",
    dealer_alert_logs_webhook_sent_on: "Webhook Sent On",
    dealer_alert_logs_webhook_attempts: "Webhook Attempts",
    dealer_alert_logs_from: "From",
    dealer_alert_logs_to: "To",
    dealer_alert_logs_apply: "Apply",
    dealer_alert_logs_resend: "Resend Webhook",
    dealer_alert_logs_payload_viewer: "Payload Viewer",
    dealer_alert_logs_error_loading: "Error loading alert logs",
};
